import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { css, styled } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import Typography from '../../Typography/index.js';
import { CloseButton, InfoIcon, Message } from './common.js';
const getColorStyles = ({ $type, theme }) => {
    switch ($type) {
        case 'success':
            return css `
        background-color: ${theme.colors.positive10};
        border: 1px solid ${theme.colors.positive30};
        & ${Typography.TextMedium} {
          color: ${theme.colors.positive120};
        }
      `;
        case 'error':
            return css `
        background-color: ${theme.colors.critical10};
        border: 1px solid ${theme.colors.critical30};
        & ${Typography.TextMedium} {
          color: ${theme.colors.critical120};
        }
      `;
        case 'warning':
            return css `
        background-color: ${theme.colors.warning10};
        border: 1px solid ${theme.colors.warning30};
        & ${Typography.TextMedium} {
          color: ${theme.colors.warning120};
        }
      `;
        default:
            return css `
        background-color: ${theme.colors.link10};
        border: 1px solid ${theme.colors.link30};
        & ${Typography.TextMedium} {
          color: ${theme.colors.link120};
        }
      `;
    }
};
const Wrapper = styled.div `
  min-height: 36px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  ${({ $clickable }) => $clickable && 'cursor: pointer;'}
  ${getColorStyles}
`;
export const BaseNotification = ({ type = 'default', title, body, className, maxHeight, closeable, onClose, onClick, role, }) => {
    const [isVisible, setIsVisible] = useState(true);
    const handleClose = useCallbackRef((e) => {
        e.stopPropagation();
        setIsVisible(false);
        onClose?.();
    });
    if (!isVisible)
        return null;
    return (_jsxs(Wrapper, { $type: type, $clickable: !!onClick, className: className, role: role, onClick: onClick, children: [_jsx(InfoIcon, { type: type }), _jsx(Message, { title: title, body: body, type: type, maxHeight: maxHeight }), closeable && _jsx(CloseButton, { closeToast: handleClose })] }));
};
